module.exports = __webpack_public_path__ + "static/media/space_cloud_aws.4ec80f71.svg";